import {
  Container,
  LogoContainer,
  Column,
  CopyrightText,
  SocialLinksContainer,
  FooterPages
} from './Footer.style';
import {
  Logo,
  TwitterIcon,
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  DiscordIcon
} from '../../assets/svg';
import { Row } from 'components/LandingScreen/Sections/LatestNews.style';

export const Footer = () => {
  return (
    <Container>
      <LogoContainer>
        <Logo />
      </LogoContainer>
      <Row>
        <FooterPages
          onClick={() => window.open('https://docs.roundpe.com/', '_blank')}
        >
          Docs
        </FooterPages>
        <FooterPages
          onClick={() => window.open('/TermsandConditions', '_self')}
        >
          Terms
        </FooterPages>
        <FooterPages onClick={() => window.open('/PrivacyPolicy', '_self')}>
          Privacy
        </FooterPages>
        <FooterPages onClick={() => window.open('/FAQs', '_self')}>
          FAQs
        </FooterPages>
      </Row>
      <Column>
        <CopyrightText>© RoundPe, 2022. All rights reserved.</CopyrightText>
        <SocialLinksContainer>
          {/* <a href="#">
            <FacebookIcon />
          </a> */}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://discord.gg/WxgRXcFfSe"
          >
            <DiscordIcon />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://twitter.com/0xRound"
          >
            <TwitterIcon />
          </a>
          {/* <a href="#">
            <InstagramIcon />
          </a> */}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.linkedin.com/company/round-finance-inc/about/"
          >
            <LinkedInIcon />
          </a>
        </SocialLinksContainer>
      </Column>
    </Container>
  );
};
